import React from 'react';
import { FieldError, FieldLabel } from '../textfield';
import { Action } from '../action/action';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Option<T = any> {
    label: string;
    value: T;
    disabled?: boolean;
    component?: React.ComponentType<{ label: string }>;
    selected?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface BoxProps<T = any> extends Option<T> {
    onClick?(): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface SelectBoxProps<T = any> {
    label: string;
    options: Option<T>[];
    required?: boolean;
    disabled?: boolean;
    value?: T;
    error?: string;
    helperText?: string;
    onChange(value: T): void;
}

const Box = <T,>({
    component: Component,
    label,
    selected,
    disabled,
    onClick
}: BoxProps<T>) => (
    <Action disabled={disabled} onClick={onClick} selected={selected}>
        {Component ? (
            <Component label={label} />
        ) : (
            <div className="flex min-h-[90px] min-w-[90px] items-center justify-center text-sm">
                {label}
            </div>
        )}
    </Action>
);

export const SelectBox = <T,>({
    value,
    onChange,
    required,
    error,
    options,
    label,
    helperText,
    disabled
}: SelectBoxProps<T>) => (
    <fieldset className="flex flex-col gap-1.5">
        <FieldLabel label={label} required={required} />
        <div className="mt-2 flex flex-wrap gap-4">
            {options.map((option) => (
                <Box
                    key={String(option.value)}
                    {...option}
                    selected={option.value === value}
                    disabled={disabled}
                    onClick={() => onChange(option.value)}
                />
            ))}
        </div>
        {helperText && (
            <p className="text-xs text-muted-foreground italic">{helperText}</p>
        )}
        <FieldError error={error} />
    </fieldset>
);
